import React from 'react';
import styled from 'styled-components';
import { detectMediaType } from '../Utils';
import MediaRenderer from '../MediaRenderer';
import { returnSaneURL } from '../../../../Utils/getImg';
import { TString } from '../../Response/Utils';

interface Props {
  data: any;
  botImageCheck: boolean;
  logoImagePath?: string;
  index: number;
}

const styleVars = getComputedStyle(document.querySelector(':root'));

const Card = styled.button`
    padding: 0;
    overflow: hidden;
    border: none;
    border-radius: 20px;
    background-color: var(--srvMsgBackground);
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 16%);
  max-width: ${(props: any) => {
    return props.typeGrid ? '440px' : '400px';
  }} !important;

  .single-card{
   img{
       max-width: 100%;
       width:auto;
    vertical-align: middle;
  }}
  .playable-video-card{
    margin-bottom:-7px;
  }
  .card-image:not(.playable-video-card):before {
    position: absolute;
    inset: 0;
    content: '';
    left: 0;
    top: 0;

    z-index: 1;
    border-radius: ${(props: any) => {
      return props.onlyImage && !props.isMultiSelect ? '20px' : '0px';
    }}
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`;

export default function SingleCard(props: Props) {
  let { botImageCheck, index, logoImagePath, data } = props;
  let title = data.card.title;
  let resourceURL = data.card.resourceURL;
  return (
    <div style={{ height: '100%' }}>
      {botImageCheck && index == 0 ? (
        <div className={'preview-image-holder'}>
          <img
            src={returnSaneURL(logoImagePath)}
            alt={TString({ labelName: 'botAvatarLabel' })}
          />
        </div>
      ) : null}
      <Card
        className={'clickable '}
        {...{
          foreground: styleVars.getPropertyValue('--srvMsgColor')
        }}
      >
        <>
          <div
            className={` single-card ${
              detectMediaType(resourceURL) === 'image'
                ? ''
                : 'playable-video-card'
            }`}
          >
            <MediaRenderer name={title} url={resourceURL} />
          </div>
        </>
      </Card>
    </div>
  );
}

// #CARDBUTTONS#
